import { HTTPVerbs, RequestOptions } from '@nextgen-web-framework/core';
import { ShopId, VersionId } from './myshopApiConstants';

export const getMyShopReqObj: RequestOptions = {
  url: `/commyshopas/${VersionId}/myshops`,
  method: HTTPVerbs.GET,
  retries: 0,
};

export const createShopReqObj: RequestOptions = {
  url: `/commyshopas/${VersionId}/myshops`,
  method: HTTPVerbs.POST,
  retries: 0,
};

export const updateShopReqObj: RequestOptions = {
  url: `/commyshopas/${VersionId}/myshops/${ShopId}`,
  method: HTTPVerbs.PUT,
  retries: 0,
};

export const uploadShopImageReqObj: RequestOptions = {
  url: `/commyshopas/${VersionId}/myshopimages`,
  method: HTTPVerbs.POST,
  retries: 0,
};
